/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAIPromptAnalyticsAzure extends models.GovernanceConfigurationBaseForAIPromptAnalytics {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAIPromptAnalyticsAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAIPromptAnalyticsAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAIPromptAnalyticsAzure>): GovernanceConfigurationForAIPromptAnalyticsAzure {
        let obj = Object.assign(new GovernanceConfigurationForAIPromptAnalyticsAzure(), model);
        GovernanceConfigurationForAIPromptAnalyticsAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAIPromptAnalyticsAzure>): GovernanceConfigurationForAIPromptAnalyticsAzure {
        if (!model) return null;
        return GovernanceConfigurationForAIPromptAnalyticsAzure.newInstance(<GovernanceConfigurationForAIPromptAnalyticsAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAIPromptAnalyticsAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForAIPromptAnalyticsAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAIPromptAnalyticsAzure): boolean {
        if (models.GovernanceConfigurationBaseForAIPromptAnalytics.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAIPromptAnalyticsAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Workspace Id
     */
    workspace_id: string;

}
